import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MatSelect } from '@angular/material';
import { ICompany } from 'src/app/interfaces/company';
import { BIDService } from 'src/app/services/common/bid.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { IBranch } from 'src/app/interfaces/branch';
import { StaticValueService } from 'src/app/services/http/business/staticValue/static-value.service';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-invoice-search',
  templateUrl: './invoice-search.component.html',
  styleUrls: ['./invoice-search.component.css']
})
export class InvoiceSearchComponent implements OnInit {
  isOwner: boolean;
  form: FormGroup;
  companyList: ICompany[];
  branchList: IBranch[];
  invoiceTypeList = [];
  InvoiceStatusList = [];

  constructor(
    private fb: FormBuilder,
    private staticValueService: StaticValueService,
    private bidService: BIDService,
    private cidService: CIDService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private holdingService: HoldingService,
    private dialog: MatDialogRef<InvoiceSearchComponent>
  ) { }

  ngOnInit() {

    this.createForm();
    this.checkOwner();
    //this.getCompanyList();
    this.getAllInvoiceItemType();
    this.getInvoiceStatus();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner)
        this.getCompanyList();
      else
        this.form.setValue({
          BranchEncryptId: this.bidService.getBID(),
        });
    });
  }

  createForm() {

    this.form = this.fb.group({
      CompanyEncryptId: [null],
      BranchEncryptId: [null],
      FullName: [null],
      NationalCode: [null],
      InvoiceItemTypeId: [null],
      InvoiceCounterNumber: [null],
      PriceStart: [null],
      PriceEnd: [null],
      CreationDateInvoiceStart: [null],
      CreationDateInvoiceEnd: [null],
      PayPersonName: [null],
      InvoiceStatusId: [null],
    });

  }

  getInvoiceStatus() {

    this.staticValueService.invoiceStatus().subscribe(
      res => {

        this.InvoiceStatusList = res;
      },
      err => {
        console.log(err);
      }
    );
  }

  getAllInvoiceItemType() {

    this.staticValueService.allInvoiceItemType().subscribe(
      res => {

        this.invoiceTypeList = res;
      },
      err => {
        console.log(err);
      }
    );
  }

  getCompanyList() {
    this.companyService.list(0,0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getBranchList(company) {


    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );

    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(res => {
      this.branchList = res.DataList;
    });



    // this.branchService.listByLogin(0, 0).subscribe(res => {
    //   this.branchList = res.DataList;
    // });
  }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.getBranchList(e.value);
  }

  setBid(e: MatSelect) {
    if (this.isOwner)
      this.bidService.setBID(e.value);
  }

  submit(data: any) {

    this.dialog.close(data);
  }

  onNoClick() {
    this.dialog.close();
  }


}
